import clsx from "clsx";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { FCC } from "@/types";

export interface ValidationToken {
  displayMessage: string;
  regex: RegExp;
}

interface Requirement extends ValidationToken {
  isFullfilled: boolean;
}

interface PasswordStrengthProps {
  customStyle?: string;
  password: string;
  validationTokens: ValidationToken[];
}

export const PasswordStrength: FCC<PasswordStrengthProps> = ({
  password,
  validationTokens,
  customStyle = "",
}) => {
  const { t } = useTranslation();
  const [requirements, setRequirements] = useState<Requirement[]>(
    validationTokens.map((token) => ({
      ...token,
      isFullfilled: false,
    })),
  );

  useEffect(() => {
    const updatedRequirements = validationTokens.map((token) => ({
      ...token,
      isFullfilled: token.regex.test(password),
    }));
    setRequirements(updatedRequirements);
  }, [password, validationTokens]);

  return (
    <>
      <p className="text-xs text-white">
        {t("translation:newWelcome.registerForm.passwordHint")}
      </p>
      <ul className={clsx("mt-0 list-disc space-y-1 pl-5", customStyle)}>
        {requirements.map((requirement, index) => (
          <li
            key={index}
            className={`text-sm transition-colors duration-300 ${requirement.isFullfilled ? "text-green-500" : "text-white"}`}
          >
            {requirement.displayMessage}
          </li>
        ))}
      </ul>
    </>
  );
};
